/* Cruciverba Farmacie Vigorito
   Vanilla JS, una istanza per section, nessuna dipendenza da Alpine.
   Registrato su window.VigoCrossword per debug e re-init manuale. */

if (!window.Eurus) { window.Eurus = { loadedScript: [] }; }
if (!window.Eurus.loadedScript) { window.Eurus.loadedScript = []; }

if (window.Eurus.loadedScript.includes('vigo-crossword.js')) {
  if (window.VigoCrossword) window.VigoCrossword.init();
} else {
  window.Eurus.loadedScript.push('vigo-crossword.js');

(function () {
  'use strict';

  var INSTANCES = {};
  var STORAGE_PREFIX = 'vigo-crossword:';

  /* ------------------------------------------------------------------
     Utility
     ------------------------------------------------------------------ */

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffle(arr, rnd) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1));
      var tmp = a[i];
      a[i] = a[j];
      a[j] = tmp;
    }
    return a;
  }

  function key(r, c) {
    return r + ',' + c;
  }

  function normalizeWord(w) {
    return String(w || '')
      .toUpperCase()
      .replace(/[ÀÁÂÃÄ]/g, 'A')
      .replace(/[ÈÉÊË]/g, 'E')
      .replace(/[ÌÍÎÏ]/g, 'I')
      .replace(/[ÒÓÔÕÖ]/g, 'O')
      .replace(/[ÙÚÛÜ]/g, 'U')
      .replace(/[^A-Z]/g, '');
  }

  function hashString(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0).toString(36);
  }

  /* ------------------------------------------------------------------
     Motore di layout
     ------------------------------------------------------------------ */

  function canPlace(cells, word, sr, sc, dir) {
    var before = dir === 'V' ? key(sr - 1, sc) : key(sr, sc - 1);
    if (cells[before]) return false;
    var after = dir === 'V' ? key(sr + word.length, sc) : key(sr, sc + word.length);
    if (cells[after]) return false;

    for (var k = 0; k < word.length; k++) {
      var r = dir === 'V' ? sr + k : sr;
      var c = dir === 'H' ? sc + k : sc;
      var existing = cells[key(r, c)];
      if (existing) {
        if (existing !== word[k]) return false;
      } else if (dir === 'V') {
        if (cells[key(r, c - 1)] || cells[key(r, c + 1)]) return false;
      } else if (cells[key(r - 1, c)] || cells[key(r + 1, c)]) {
        return false;
      }
    }
    return true;
  }

  function commit(cells, placed, entry, sr, sc, dir) {
    for (var k = 0; k < entry.word.length; k++) {
      var r = dir === 'V' ? sr + k : sr;
      var c = dir === 'H' ? sc + k : sc;
      cells[key(r, c)] = entry.word[k];
    }
    placed.push({ id: entry.id, word: entry.word, clue: entry.clue, r: sr, c: sc, dir: dir });
  }

  function tryLayout(anchored, free) {
    var cells = {};
    var placed = [];
    var skipped = [];
    var i;

    for (i = 0; i < anchored.length; i++) {
      var a = anchored[i];
      if (canPlace(cells, a.word, a.r - 1, a.c - 1, a.dir)) {
        commit(cells, placed, a, a.r - 1, a.c - 1, a.dir);
      } else {
        skipped.push(a);
      }
    }

    var queue = free.slice();
    if (!placed.length && queue.length) {
      var first = queue.shift();
      commit(cells, placed, first, 0, 0, first.dir === 'V' ? 'V' : 'H');
    }

    for (i = 0; i < queue.length; i++) {
      var w = queue[i];
      var best = null;

      for (var li = 0; li < w.word.length; li++) {
        for (var pi2 = 0; pi2 < placed.length; pi2++) {
          var p = placed[pi2];
          for (var pi = 0; pi < p.word.length; pi++) {
            if (p.word[pi] !== w.word[li]) continue;

            var dir = p.dir === 'H' ? 'V' : 'H';
            if (w.dir === 'H' || w.dir === 'V') {
              if (dir !== w.dir) continue;
            }
            var cr = p.dir === 'H' ? p.r : p.r + pi;
            var cc = p.dir === 'H' ? p.c + pi : p.c;
            var sr = dir === 'V' ? cr - li : cr;
            var sc = dir === 'V' ? cc : cc - li;

            if (!canPlace(cells, w.word, sr, sc, dir)) continue;

            var cross = 0;
            for (var k = 0; k < w.word.length; k++) {
              var rr = dir === 'V' ? sr + k : sr;
              var ck = dir === 'H' ? sc + k : sc;
              if (cells[key(rr, ck)]) cross++;
            }
            if (!best || cross > best.cross) best = { sr: sr, sc: sc, dir: dir, cross: cross };
          }
        }
      }

      if (best) commit(cells, placed, w, best.sr, best.sc, best.dir);
      else skipped.push(w);
    }

    if (!placed.length) return null;

    var minR = Infinity;
    var minC = Infinity;
    var maxR = -Infinity;
    var maxC = -Infinity;
    Object.keys(cells).forEach(function (k) {
      var parts = k.split(',');
      var r = parseInt(parts[0], 10);
      var c = parseInt(parts[1], 10);
      if (r < minR) minR = r;
      if (c < minC) minC = c;
      if (r > maxR) maxR = r;
      if (c > maxC) maxC = c;
    });

    var normalized = placed.map(function (p) {
      return { id: p.id, word: p.word, clue: p.clue, r: p.r - minR, c: p.c - minC, dir: p.dir };
    });

    return {
      placed: normalized,
      width: maxC - minC + 1,
      height: maxR - minR + 1,
      skipped: skipped
    };
  }

  function buildLayout(words, seed) {
    var anchored = words.filter(function (w) {
      return w.r > 0 && w.c > 0 && (w.dir === 'H' || w.dir === 'V');
    });
    var free = words.filter(function (w) {
      return anchored.indexOf(w) === -1;
    });

    var best = null;
    var attempts = free.length > 1 ? 300 : 1;

    for (var a = 0; a < attempts; a++) {
      var rnd = mulberry32((seed || 1) * 7919 + a);
      var order = shuffle(free, rnd).sort(function (x, y) {
        return y.word.length - x.word.length;
      });
      var layout = tryLayout(anchored, order);
      if (!layout) continue;

      var score = layout.placed.length * 1000 - (layout.width + layout.height);
      if (!best || score > best.score) {
        layout.score = score;
        best = layout;
      }
      if (best.placed.length === words.length && a > 60) break;
    }
    return best;
  }

  /* ------------------------------------------------------------------
     Componente
     ------------------------------------------------------------------ */

  function Crossword(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');

    var configEl = root.querySelector('[data-vc-config]');
    if (!configEl) return;

    try {
      this.cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[vigo-crossword] configurazione non valida', e);
      return;
    }

    this.words = (this.cfg.words || [])
      .map(function (w) {
        return {
          id: w.id,
          word: normalizeWord(w.word),
          clue: w.clue || '',
          r: parseInt(w.r, 10) || 0,
          c: parseInt(w.c, 10) || 0,
          dir: w.dir === 'H' || w.dir === 'V' ? w.dir : 'auto'
        };
      })
      .filter(function (w) {
        return w.word.length > 1;
      });

    this.tips = (this.cfg.tips || []).filter(function (t) {
      return t.text || t.action !== 'none';
    });

    this.el = {
      grid: root.querySelector('[data-vc-grid]'),
      across: root.querySelector('[data-vc-across]'),
      down: root.querySelector('[data-vc-down]'),
      bar: root.querySelector('[data-vc-bar]'),
      progressText: root.querySelector('[data-vc-progress-text]'),
      helperMsg: root.querySelector('[data-vc-helper-msg]'),
      helperAsk: root.querySelector('[data-vc-helper-ask]'),
      helpYes: root.querySelector('[data-vc-help-yes]'),
      helpNo: root.querySelector('[data-vc-help-no]'),
      check: root.querySelector('[data-vc-check]'),
      reset: root.querySelector('[data-vc-reset]'),
      overlay: root.querySelector('[data-vc-overlay]'),
      modal: root.querySelector('[data-vc-modal]'),
      copy: root.querySelector('[data-vc-copy]'),
      reopen: root.querySelector('[data-vc-reopen]'),
      sr: root.querySelector('[data-vc-sr]'),
      warn: root.querySelector('[data-vc-warn]')
    };

    this.state = {
      activeEntry: null,
      activeDir: 'H',
      won: false,
      justFocused: false,
      tipIndex: 0,
      idleTimer: null,
      started: false
    };

    this.storageKey =
      STORAGE_PREFIX +
      hashString(
        this.words
          .map(function (w) {
            return w.word;
          })
          .join('|') +
          ':' +
          this.cfg.seed
      );

    this.onResize = this.setCellSize.bind(this);

    this.init();
  }

  Crossword.prototype.init = function () {
    if (!this.el.grid || !this.words.length) return;

    this.layout = buildLayout(this.words, this.cfg.seed);
    if (!this.layout) {
      this.warn('Nessuna parola posizionabile: controlla le parole e gli ancoraggi.');
      return;
    }

    if (this.layout.skipped && this.layout.skipped.length) {
      this.warn(
        'Parole non posizionate: ' +
          this.layout.skipped
            .map(function (w) {
              return w.word;
            })
            .join(', ') +
          '. Cambia il seed o togli gli ancoraggi in conflitto.'
      );
    }

    this.render();
    this.bind();
    this.restore();
    this.updateProgress();
    this.armIdle();
  };

  Crossword.prototype.warn = function (msg) {
    if (this.el.warn) {
      this.el.warn.textContent = msg;
      this.el.warn.hidden = false;
    }
    console.warn('[vigo-crossword] ' + msg);
  };

  Crossword.prototype.render = function () {
    var self = this;
    var placed = this.layout.placed.slice().sort(function (a, b) {
      return a.r - b.r || a.c - b.c;
    });

    var numbers = {};
    var num = 0;
    placed.forEach(function (p) {
      var k = key(p.r, p.c);
      if (numbers[k] === undefined) numbers[k] = ++num;
      p.num = numbers[k];
    });

    this.cells = {};
    placed.forEach(function (p) {
      for (var k = 0; k < p.word.length; k++) {
        var r = p.dir === 'V' ? p.r + k : p.r;
        var c = p.dir === 'H' ? p.c + k : p.c;
        var kk = key(r, c);
        if (!self.cells[kk]) self.cells[kk] = { r: r, c: c, letter: p.word[k], entries: [] };
      }
    });

    this.el.grid.innerHTML = '';
    this.el.grid.style.gridTemplateColumns = 'repeat(' + this.layout.width + ', var(--vc-cell))';

    var labelTemplate = (this.cfg.labels && this.cfg.labels.cellLabel) || 'Cella riga [r] colonna [c]';

    for (var r = 0; r < this.layout.height; r++) {
      for (var c = 0; c < this.layout.width; c++) {
        var cell = document.createElement('div');
        cell.className = 'vc-cell';
        var data = this.cells[key(r, c)];

        if (!data) {
          cell.classList.add('is-block');
          this.el.grid.appendChild(cell);
          continue;
        }

        var start = placed.filter(function (p) {
          return p.r === data.r && p.c === data.c;
        })[0];
        if (start) {
          var span = document.createElement('span');
          span.className = 'vc-num';
          span.textContent = start.num;
          cell.appendChild(span);
        }

        var input = document.createElement('input');
        input.type = 'text';
        input.maxLength = 1;
        input.autocomplete = 'off';
        input.autocapitalize = 'characters';
        input.setAttribute('inputmode', 'text');
        input.setAttribute(
          'aria-label',
          labelTemplate.replace('[r]', r + 1).replace('[c]', c + 1)
        );
        input.dataset.r = r;
        input.dataset.c = c;

        data.input = input;
        data.cellEl = cell;
        cell.appendChild(input);
        this.el.grid.appendChild(cell);
      }
    }

    this.entries = placed.map(function (p) {
      var list = [];
      for (var k = 0; k < p.word.length; k++) {
        var r = p.dir === 'V' ? p.r + k : p.r;
        var c = p.dir === 'H' ? p.c + k : p.c;
        var d = self.cells[key(r, c)];
        d.entries.push(p);
        list.push(d);
      }
      p.cells = list;
      return p;
    });

    this.buildClues();
    this.setCellSize();
  };

  Crossword.prototype.buildClues = function () {
    var self = this;
    this.el.across.innerHTML = '';
    this.el.down.innerHTML = '';

    this.entries
      .slice()
      .sort(function (a, b) {
        return a.num - b.num;
      })
      .forEach(function (entry) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vc-clue';
        btn.setAttribute('data-vc-block-id', entry.id || '');
        btn.innerHTML =
          '<span class="vc-clue__n"></span><span class="vc-clue__text"></span>';
        btn.querySelector('.vc-clue__n').textContent = entry.num;
        btn.querySelector('.vc-clue__text').textContent = entry.clue;
        btn.addEventListener('click', function () {
          self.focusEntry(entry);
        });
        entry.clueEl = btn;
        (entry.dir === 'H' ? self.el.across : self.el.down).appendChild(btn);
      });
  };

  Crossword.prototype.setCellSize = function () {
    if (!this.layout) return;

    var board = this.root.querySelector('[data-vc-board]');
    var total = (board && board.clientWidth) || this.root.clientWidth || 320;

    var sideBySide =
      window.innerWidth >= 1024 && board && board.classList.contains('vc-board--side');

    var budget = sideBySide ? Math.max(300, total * 0.58 - 32) : total;
    budget -= window.innerWidth >= 768 ? 30 : 22;

    var max =
      parseInt(getComputedStyle(this.root).getPropertyValue('--vc-cell-max'), 10) || 44;

    var gap =
      parseInt(getComputedStyle(this.root).getPropertyValue('--vc-gap'), 10) || 3;

    var size = Math.floor((budget - (this.layout.width - 1) * gap) / this.layout.width);
    size = Math.max(24, Math.min(max, size));

    this.root.style.setProperty('--vc-cell', size + 'px');
  };

  /* ---- input e navigazione ---- */

  Crossword.prototype.bind = function () {
    var self = this;

    Object.keys(this.cells).forEach(function (k) {
      var data = self.cells[k];
      var input = data.input;

      input.addEventListener('focus', function () {
        self.state.justFocused = true;
        var entry =
          data.entries.filter(function (e) {
            return e.dir === self.state.activeDir;
          })[0] || data.entries[0];
        self.state.activeDir = entry.dir;
        self.setActive(entry);
        self.touch();
      });

      input.addEventListener('click', function () {
        var wasNewFocus = self.state.justFocused;
        self.state.justFocused = false;
        if (wasNewFocus) return;
        if (data.entries.length < 2) return;
        var other = data.entries.filter(function (e) {
          return e.dir !== self.state.activeDir;
        })[0];
        if (!other) return;
        self.state.activeDir = other.dir;
        self.setActive(other);
      });

      input.addEventListener('input', function () {
        input.value = normalizeWord(input.value).slice(0, 1);
        input.parentElement.classList.remove('is-wrong');
        self.touch();
        if (input.value) self.advance(input, 1, false);
        self.refreshSolved();
        self.updateProgress();
        self.save();
        self.maybeWin();
      });

      input.addEventListener('keydown', function (e) {
        var r = parseInt(input.dataset.r, 10);
        var c = parseInt(input.dataset.c, 10);

        if (e.key === 'Backspace') {
          if (!input.value) {
            e.preventDefault();
            self.advance(input, -1, true);
          }
          self.touch();
          setTimeout(function () {
            self.refreshSolved();
            self.updateProgress();
            self.save();
          }, 0);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          self.move(r, c, 0, 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          self.move(r, c, 0, -1);
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          self.move(r, c, 1, 0);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          self.move(r, c, -1, 0);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          self.jumpNextEntry();
        } else if (e.key === ' ') {
          e.preventDefault();
          self.toggleDir(data);
        }
      });
    });

    if (this.el.check) {
      this.el.check.addEventListener('click', this.check.bind(this));
    }
    if (this.el.reset) {
      this.el.reset.addEventListener('click', this.reset.bind(this));
    }
    if (this.el.helpYes) {
      this.el.helpYes.addEventListener('click', this.acceptTip.bind(this));
    }
    if (this.el.helpNo) {
      this.el.helpNo.addEventListener('click', this.declineTip.bind(this));
    }
    if (this.el.copy) {
      this.el.copy.addEventListener('click', this.copyCoupon.bind(this));
    }
    if (this.el.reopen) {
      this.el.reopen.addEventListener('click', this.openOverlay.bind(this));
    }

    this.root.querySelectorAll('[data-vc-overlay-close]').forEach(function (el) {
      el.addEventListener('click', self.closeOverlay.bind(self));
    });

    this.onKeydown = function (e) {
      if (e.key === 'Escape' && self.el.overlay && self.el.overlay.classList.contains('is-open')) {
        self.closeOverlay();
      }
    };
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('resize', this.onResize);
  };

  Crossword.prototype.move = function (r, c, dr, dc) {
    var nr = r + dr;
    var nc = c + dc;
    while (nr >= 0 && nc >= 0 && nr < this.layout.height && nc < this.layout.width) {
      var data = this.cells[key(nr, nc)];
      if (data) {
        data.input.focus();
        return;
      }
      nr += dr;
      nc += dc;
    }
  };

  Crossword.prototype.toggleDir = function (data) {
    this.state.justFocused = false;
    if (data.entries.length < 2) return;
    var self = this;
    var other = data.entries.filter(function (e) {
      return e.dir !== self.state.activeDir;
    })[0];
    if (other) {
      this.state.activeDir = other.dir;
      this.setActive(other);
    }
  };

  Crossword.prototype.advance = function (input, step, clear) {
    var entry = this.state.activeEntry;
    if (!entry) return;

    var index = -1;
    for (var i = 0; i < entry.cells.length; i++) {
      if (entry.cells[i].input === input) index = i;
    }
    if (index === -1) return;

    var immediate = entry.cells[index + step];

    if (step > 0 && !clear) {
      var j = index + 1;
      while (j < entry.cells.length && entry.cells[j].input.value) j++;
      if (j < entry.cells.length) {
        entry.cells[j].input.focus();
        return;
      }
      var wrap = 0;
      while (wrap < index && entry.cells[wrap].input.value) wrap++;
      if (wrap < index && !entry.cells[wrap].input.value) {
        entry.cells[wrap].input.focus();
        return;
      }
    }

    if (!immediate) return;
    immediate.input.focus();
    if (clear) immediate.input.value = '';
  };

  Crossword.prototype.focusEntry = function (entry) {
    this.state.activeDir = entry.dir;
    this.setActive(entry);
    var target =
      entry.cells.filter(function (d) {
        return !d.input.value;
      })[0] || entry.cells[0];
    target.input.focus();
    this.touch();
  };

  Crossword.prototype.jumpNextEntry = function () {
    var current = this.entries.indexOf(this.state.activeEntry);
    for (var k = 1; k <= this.entries.length; k++) {
      var entry = this.entries[(current + k) % this.entries.length];
      if (!this.isSolved(entry)) {
        this.focusEntry(entry);
        return;
      }
    }
  };

  Crossword.prototype.setActive = function (entry) {
    var self = this;
    this.state.activeEntry = entry;
    this.root.querySelectorAll('.vc-cell').forEach(function (cell) {
      cell.classList.remove('is-active');
    });
    entry.cells.forEach(function (d) {
      d.cellEl.classList.add('is-active');
    });
    this.entries.forEach(function (e) {
      if (e.clueEl) e.clueEl.classList.toggle('is-active', e === entry);
    });
    if (!this.state.started) {
      this.state.started = true;
      self.track('crossword_start', {});
    }
  };

  /* ---- stato e progresso ---- */

  Crossword.prototype.isSolved = function (entry) {
    return entry.cells.every(function (d) {
      return d.input.value === d.letter;
    });
  };

  Crossword.prototype.refreshSolved = function () {
    var self = this;
    this.entries.forEach(function (entry) {
      var solved = self.isSolved(entry);
      if (entry.clueEl) entry.clueEl.classList.toggle('is-done', solved);
    });
    Object.keys(this.cells).forEach(function (k) {
      var data = self.cells[k];
      var solved = data.entries.some(function (e) {
        return self.isSolved(e);
      });
      data.cellEl.classList.toggle('is-solved', solved);
    });
  };

  Crossword.prototype.updateProgress = function () {
    var self = this;
    var keys = Object.keys(this.cells);
    var correct = 0;
    keys.forEach(function (k) {
      if (self.cells[k].input.value === self.cells[k].letter) correct++;
    });
    var pct = keys.length ? Math.round((correct / keys.length) * 100) : 0;
    if (this.el.bar) this.el.bar.style.width = pct + '%';
    if (this.el.progressText) this.el.progressText.textContent = pct + '%';
    this.refreshSolved();
  };

  Crossword.prototype.check = function () {
    var self = this;
    var wrong = 0;

    if (this.state.won) {
      this.openOverlay();
      return;
    }

    Object.keys(this.cells).forEach(function (k) {
      var data = self.cells[k];
      if (data.input.value && data.input.value !== data.letter) {
        wrong++;
        data.cellEl.classList.add('is-wrong');
        setTimeout(function () {
          data.cellEl.classList.remove('is-wrong');
        }, 1200);
      }
    });

    if (this.allSolved()) {
      this.maybeWin();
    } else if (wrong) {
      this.say(this.cfg.labels.checkWrong);
    } else {
      this.say(this.cfg.labels.checkOk);
    }
    this.track('crossword_check', { crossword_wrong_letters: wrong });
    this.touch();
  };

  Crossword.prototype.allSolved = function () {
    var self = this;
    return this.entries.every(function (e) {
      return self.isSolved(e);
    });
  };

  Crossword.prototype.maybeWin = function () {
    if (this.state.won || !this.allSolved()) return;
    this.state.won = true;
    clearTimeout(this.state.idleTimer);
    this.hideAsk();
    this.say(this.cfg.labels.win);
    if (this.el.reopen) this.el.reopen.hidden = false;
    this.openOverlay();
    this.confetti();
    this.track('crossword_complete', { crossword_hints_used: this.state.tipIndex });
  };

  Crossword.prototype.reset = function () {
    var self = this;
    if (!this.state.won && !window.confirm(this.cfg.labels.restartConfirm)) return;

    Object.keys(this.cells).forEach(function (k) {
      self.cells[k].input.value = '';
      self.cells[k].cellEl.classList.remove('is-solved', 'is-wrong', 'is-hinted');
    });
    this.state.won = false;
    this.state.tipIndex = 0;
    if (this.el.reopen) this.el.reopen.hidden = true;
    this.closeOverlay();
    this.clearSave();
    this.updateProgress();
    this.say(this.cfg.labels.intro);
    this.armIdle();
    this.track('crossword_restart', {});
  };

  /* ---- aiuti ---- */

  Crossword.prototype.say = function (text) {
    if (!this.el.helperMsg) return;
    var name = this.cfg.helperName;
    this.el.helperMsg.innerHTML = '';
    if (name) {
      var strong = document.createElement('span');
      strong.className = 'vc-helper__name';
      strong.textContent = name + ': ';
      this.el.helperMsg.appendChild(strong);
    }
    this.el.helperMsg.appendChild(document.createTextNode(text || ''));
    if (this.el.sr) this.el.sr.textContent = text || '';
  };

  Crossword.prototype.touch = function () {
    this.hideAsk();
    this.armIdle();
  };

  Crossword.prototype.armIdle = function () {
    clearTimeout(this.state.idleTimer);
    if (this.state.won) return;
    var tip = this.tips[this.state.tipIndex];
    if (!tip) return;
    var self = this;
    this.state.idleTimer = setTimeout(function () {
      self.offerTip();
    }, (parseInt(tip.delay, 10) || 30) * 1000);
  };

  Crossword.prototype.offerTip = function () {
    if (this.state.won || !this.el.helperAsk) return;
    if (!this.tips[this.state.tipIndex]) return;
    this.el.helperAsk.hidden = false;
    this.track('crossword_hint_offered', { crossword_hint_index: this.state.tipIndex + 1 });
  };

  Crossword.prototype.hideAsk = function () {
    if (this.el.helperAsk) this.el.helperAsk.hidden = true;
  };

  Crossword.prototype.declineTip = function () {
    this.hideAsk();
    this.track('crossword_hint_declined', { crossword_hint_index: this.state.tipIndex + 1 });
    var tip = this.tips[this.state.tipIndex];
    if (!tip) return;
    var self = this;
    clearTimeout(this.state.idleTimer);
    this.state.idleTimer = setTimeout(function () {
      self.offerTip();
    }, (parseInt(tip.delay, 10) || 30) * 1500);
  };

  Crossword.prototype.acceptTip = function () {
    var tip = this.tips[this.state.tipIndex];
    this.hideAsk();
    if (!tip) return;

    var index = this.state.tipIndex + 1;
    this.state.tipIndex++;

    var unsolved = this.entries.filter(
      function (e) {
        return !this.isSolved(e);
      }.bind(this)
    );

    var message = tip.text || '';

    if (unsolved.length && tip.action === 'highlight') {
      var easiest = unsolved.slice().sort(function (a, b) {
        return a.word.length - b.word.length;
      })[0];
      this.focusEntry(easiest);
      if (easiest.clueEl) easiest.clueEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      message =
        (message ? message + ' ' : '') + this.cfg.labels.startFrom + ' ' + easiest.clue + '.';
    } else if (unsolved.length && tip.action === 'letter') {
      var self = this;
      var target = unsolved
        .slice()
        .sort(function (a, b) {
          return self.missingCount(a) - self.missingCount(b);
        })[0];
      var cell = target.cells.filter(function (d) {
        return d.input.value !== d.letter;
      })[0];
      if (cell) {
        cell.input.value = cell.letter;
        cell.cellEl.classList.add('is-hinted');
        setTimeout(function () {
          cell.cellEl.classList.remove('is-hinted');
        }, 600);
        message = (message ? message + ' ' : '') + this.cfg.labels.letterGift;
        this.updateProgress();
        this.save();
      }
    }

    this.say(message);
    this.track('crossword_hint_accepted', { crossword_hint_index: index });

    if (!this.tips[this.state.tipIndex] && this.cfg.labels.noMoreTips) {
      var self2 = this;
      setTimeout(function () {
        if (!self2.state.won) self2.say(self2.cfg.labels.noMoreTips);
      }, 6000);
    }

    this.maybeWin();
    this.armIdle();
  };

  Crossword.prototype.missingCount = function (entry) {
    return entry.cells.filter(function (d) {
      return d.input.value !== d.letter;
    }).length;
  };

  /* ---- overlay e coupon ---- */

  Crossword.prototype.openOverlay = function () {
    if (!this.el.overlay) return;
    this.el.overlay.hidden = false;
    this.el.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = this.el.modal && this.el.modal.querySelector('button, a');
    if (focusable) focusable.focus();
  };

  Crossword.prototype.closeOverlay = function () {
    if (!this.el.overlay) return;
    this.el.overlay.classList.remove('is-open');
    this.el.overlay.hidden = true;
    document.body.style.overflow = '';
  };

  Crossword.prototype.copyCoupon = function () {
    var self = this;
    var code = this.cfg.coupon || '';
    if (!code) return;

    var label = this.el.copy.querySelector('.button-text');
    var done = function () {
      if (label) {
        label.textContent = self.cfg.labels.copied;
        setTimeout(function () {
          label.textContent = self.cfg.labels.copy;
        }, 2000);
      }
      self.track('crossword_coupon_copy', { crossword_coupon: code });
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch (e) {}
      ta.remove();
      done();
    }
  };

  Crossword.prototype.confetti = function () {
    if (!this.el.modal) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var box = this.el.modal.querySelector('.vc-confetti');
    if (!box) {
      box = document.createElement('div');
      box.className = 'vc-confetti';
      this.el.modal.appendChild(box);
    }
    box.innerHTML = '';

    var colors = [
      'rgba(var(--colors-text-link))',
      'rgba(var(--color-success))',
      'rgb(var(--colors-heading))'
    ];
    for (var i = 0; i < 60; i++) {
      var piece = document.createElement('i');
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[i % colors.length];
      piece.style.animationDuration = 2 + Math.random() * 2 + 's';
      piece.style.animationDelay = Math.random() * 0.6 + 's';
      box.appendChild(piece);
    }
  };

  /* ---- persistenza e tracking ---- */

  Crossword.prototype.save = function () {
    if (!this.cfg.saveProgress) return;
    var self = this;
    var data = {};
    Object.keys(this.cells).forEach(function (k) {
      if (self.cells[k].input.value) data[k] = self.cells[k].input.value;
    });
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (e) {}
  };

  Crossword.prototype.restore = function () {
    if (!this.cfg.saveProgress) return;
    var raw;
    try {
      raw = localStorage.getItem(this.storageKey);
    } catch (e) {
      return;
    }
    if (!raw) return;
    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    var self = this;
    Object.keys(data).forEach(function (k) {
      if (self.cells[k]) self.cells[k].input.value = data[k];
    });
  };

  Crossword.prototype.clearSave = function () {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {}
  };

  Crossword.prototype.track = function (event, params) {
    if (!this.cfg.tracking) return;
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event, crossword_id: this.sectionId };
    Object.keys(params || {}).forEach(function (k) {
      payload[k] = params[k];
    });
    window.dataLayer.push(payload);
  };

  Crossword.prototype.destroy = function () {
    clearTimeout(this.state.idleTimer);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('keydown', this.onKeydown);
  };

  /* ------------------------------------------------------------------
     Bootstrap
     ------------------------------------------------------------------ */

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('[data-vigo-crossword]');
    roots.forEach(function (root) {
      var id = root.getAttribute('data-section-id');
      if (INSTANCES[id]) INSTANCES[id].destroy();
      INSTANCES[id] = new Crossword(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && INSTANCES[id]) {
      INSTANCES[id].destroy();
      delete INSTANCES[id];
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var blockId = e.detail && e.detail.blockId;
    if (!blockId) return;
    var clue = document.querySelector('[data-vc-block-id="' + blockId + '"]');
    if (!clue) return;
    clue.click();
    clue.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  window.VigoCrossword = { instances: INSTANCES, init: initAll };
})();

}
